<div class="toast-stack" [ngClass]="stackDirection">
  @for (t of toasts; track t.id) {
  <div
    class="toast-wrapper"
    [attr.data-id]="t.id"
    [class.visible]="t.visible"
    #wrapperEl
    (touchstart)="startSwipe($event, wrapperEl)"
    (touchmove)="moveSwipe($event, wrapperEl)"
    (touchend)="endSwipe(wrapperEl, t)"
    (mousedown)="startSwipe($event, wrapperEl)"
    (mousemove)="moveSwipe($event, wrapperEl)"
    (mouseup)="endSwipe(wrapperEl, t)"
  >
    <div
      class="toast-card"
      [ngClass]="t.type"
      [class.visible]="t.visible"
      [class.removing]="t.removing"
      (click)="removeOnClick(t)"
    >
      <!-- EXTRA BACKGROUND LAYER -->
      <div class="toast-bg" [ngClass]="t.type"></div>

      <ion-icon class="toast-icon" [name]="icon(t.type)"></ion-icon>

      <p class="toast-message">{{ t.message }}</p>

      @if (t.buttonText) {
      <app-btn
        [text]="t.buttonText"
        [type]="btnType(t.type)"
        (clicked)="handleToastAction(t)"
      ></app-btn>
      }

      <div class="toast-progress">
        <span
          class="bar"
          [ngClass]="t.type"
          [style.transform]="'scaleX(' + (t.progress ?? 100) / 100 + ')'"
        ></span>
      </div>
    </div>
  </div>
  }
</div>
